import styled from "styled-components";
import {
	FONT_WT_HEAVY,
	MOBILE_L_BP,
	TABLET_M_BP,
} from "@website-builder/utilities-index";

export const UniversityWrapper = styled.main`
	font-size: 1rem;
	color: var(--theme-dark-font-color);

	h1,
	h2,
	strong,
	b {
		font-weight: ${FONT_WT_HEAVY};
	}
	${({ preHeroBannerPadding }) => `
    .rebrand-section, .paid-rebrand-footer, .rebrand-footer {
      position: relative;
      top: ${preHeroBannerPadding?.[0] || 72}px;
      @media only screen and (max-width: ${MOBILE_L_BP}px){
          top: ${preHeroBannerPadding?.[1] || 72}px;
      }
    }
    
  `}

	.main-wrapper {
		margin: 40px 0;

		@media only screen and (max-width: ${TABLET_M_BP}px) {
			margin: 0;
			margin-bottom: 40px;
		}
	}

	.blog-banner-wr,
	.latest-posts {
		margin-bottom: 48px;
	}
`;
